module.exports = __webpack_public_path__ + "static/media/All-Star-Fitness.9136d07e.png";